import { useContext, useEffect } from 'react';
import { useSearchParams } from '@shared/hooks';
import { useCashRegisterOperationsTableColumns } from './use-cash-register-operations-table-columns';
import { CashRegisterOperationsTableContext } from '../../context';

export const useCashRegisterOperationsTable = () => {
  const { handleFetch } = useContext(CashRegisterOperationsTableContext);
  const columns = useCashRegisterOperationsTableColumns();
  const { searchParams, remove } = useSearchParams<{
    reFetchCashRegisterOperationsTable?: string;
  }>();

  useEffect(() => {
    (async () => {
      if (searchParams.reFetchCashRegisterOperationsTable) {
        remove.current('reFetchCashRegisterOperationsTable');
        await handleFetch();
      }
    })();
  }, [handleFetch, remove, searchParams.reFetchCashRegisterOperationsTable]);

  return { columns };
};
